
import { Directive, ElementRef } from '@angular/core';
import { CustomNotification } from '../CustomNotification';
import { Utilities } from '../Utilities';

@Directive({
    selector: '[restrictHtmlTags]'
})

export class RestrictHtmlTagsDirective {
    constructor(public el: ElementRef,
        public customNotification: CustomNotification) {
        this.el.nativeElement.onkeypress = (evt) => {
            let allowKeys = [60, 62];
            if (allowKeys.some(x => x === evt.which)) {
                evt.preventDefault();
            }
        };
        this.el.nativeElement.onpaste = (evt) => {
            let clipBoardData: string = evt.clipboardData.getData("text/plain");
            if (clipBoardData.includes("<") || clipBoardData.includes(">")) {
                this.customNotification.notify("You can't enter '<' or '>'", "", Utilities.error);
                evt.preventDefault();
            }
        };
    }
}


// WEBPACK FOOTER //
// ./src/app/Directives/restrict-html-tags.Directive.ts